import { createFileRoute } from '@tanstack/react-router'
import { CrewDirectory } from '@/components/CrewDirectory';
import { z } from 'zod';

const crewDirectorySearchSchema = z.object({
  search: z.string().optional(),
  openDrawer: z.boolean().optional(),
});

export const Route = createFileRoute('/_auth/operations/crew-directory/')({
  validateSearch: crewDirectorySearchSchema,
  component: CrewDirectoryRoute,
})

function CrewDirectoryRoute() {
  const { search, openDrawer } = Route.useSearch();

  return <CrewDirectory initialSearch={search} initialOpenDrawer={openDrawer} />;
}
